import { Box } from '@jfs/ui-new'

export const SeparatorLine = () => {
  return <Box h={1} bg="SEPERATOR" marginHorizontal={'6%'} />
}
